export default __webpack_public_path__ + "static/media/Image type.a31ecc79.svg";